var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import { VideoPreviewWrapper, Title, TextColumn } from "./Video.styled";
import Grid from "../Grid";

var Video = function Video(_a) {
  var title = _a.title,
      subtitle = _a.subtitle,
      youTubeVideoUrl = _a.youTubeVideoUrl,
      props = __rest(_a, ["title", "subtitle", "youTubeVideoUrl"]);

  return React.createElement(Grid.Container, __assign({}, props), React.createElement(Grid.Row, null, React.createElement(TextColumn, {
    xs: 12,
    md: 5
  }, React.createElement(Title, null, title), React.createElement("p", null, subtitle)), React.createElement(Grid.Col, {
    xs: 12,
    md: 7
  }, React.createElement(VideoPreviewWrapper, null, React.createElement("iframe", {
    src: youTubeVideoUrl,
    title: title,
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true
  })))));
};

export default Video;